import React from 'react';
import classes from './Renewals.module.scss';

const Renewals = () => {
    return (
        <div className={classes.Renewals}>
            <h1>Contract renewals and upgrades</h1>
            <p>Here are the available options and the related legal terms.</p>
            <table>
                <thead>
                <tr>
                    <th>What do you want to do?</th>
                    <th>Option</th>
                    <th>Contract terms</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td rowSpan="2">Renew or upgrade the contract</td>
                    <td>Start a new contract cycle</td>
                    <td>Upgrade to a higher plan or renew the existing plan early, with a new expiration date and
                        consumed pages reset to zero.
                    </td>
                </tr>
                <tr>
                    <td>Keep the current contract cycle</td>
                    <td>Upgrade to a plan with more pages while keeping the original expiration dates and the number of
                        pages already used. A discount equal to the value of the current plan is applied.
                    </td>
                </tr>
                <tr>
                    <td>Purchase pages without changing the existing contract</td>
                    <td>One-time page purchase</td>
                    <td>Extraordinary purchase of a lower plan if pages are exhausted before the natural expiration.
                        The existing contract dates remain unchanged and any applicable discounts are halved.
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    );
};

export default Renewals;
